<template>  
    <!-- View Detail Main Start -->
    <b-modal
      v-model="showModal"
      size="xl"
      scrollable
      title-class="font-18"
      hide-footer
      @hidden="onModalHide"
    >
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h5 v-for="supplierDetail in supplierDetails.data" :key="supplierDetail.supplier_id">
            <template v-if="supplierDetail.sub_product_id == subProductId">
                Supplier | {{ supplierDetail.producer_company_name }}
            </template>
        </h5>
        <div>  
        <button @click="close()" class="close">
          <i class="fas fa-times"></i>
        </button>
        </div>
      </template>
          <template>
                <div class="row sections-main">
                  <div class="col-md-10 mt-3">
                    <table class="table supplier-details">
                      <thead>
                        <th>
                          {{ trans.get("__JSON__.Product Name") }}
                        </th>
                        <th>
                          {{ trans.get("__JSON__.Supplier") }}
                        </th>
                        <th>
                          {{ trans.get("__JSON__.Purchasing Price") }}
                        </th>
                        <th>
                          {{ trans.get("__JSON__.Tax") }}
                        </th>
                      </thead>
                      <tbody>
                        <tr v-for="supplierDetail in supplierDetails.data" :key="supplierDetail.supplier_id">
                            <template v-if="supplierDetail.sub_product_id == subProductId">
                                <td>{{ supplierDetail.item_name }}</td>
                                <td>{{ supplierDetail.producer_company_name }}</td>
                                <td>{{ supplierDetail.price_excluding_tax }} / {{ supplierDetail.price_including_tax }}</td>
                                <td>{{ supplierDetail.tax }}</td>
                            </template>
                           
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
          </template>
         
    </b-modal>
  </template>
  
  <script>
  import { supplierService } from '../../services';
  import config from "../../config";
  import { base64,success_message,error_message } from "../../Helper/helper";
  export default {
      components : {},  
      props :['supplierdata','subProductId'],
      data(){
          return {
              config:config,
              orderLoading: false,
              showModal: false,
              supplierDetails: [],
              subProductId:this.$props.subProductId
          }
      },
      mounted(){
          this.viewDetails();
      },
      methods : {
        async viewDetails(){
          this.showModal = true;
          this.orderLoading = true;
          this.supplierDetails = this.$props.supplierdata;
          this.subProductId = this.$props.subProductId;
          console.log(this.$props)
        },
        modalShow(value){
          this.showModal = value;
          this.$emit("actionChanged");
        },
        onModalHide(){
          this.showModal = false;
          this.$emit('hidden');
        },
      }
  }
  </script>
  
  <style>
  .supplier-details td {
   background-color: rgb(218, 218, 218);
   border: 1px solid #eff2f7 !important;
   padding : 0.35rem !important;
  }
  .supplier-details th {
   background-color: rgb(185, 182, 182);
    border: 1px solid #eff2f7 !important;
    padding : 0.35rem !important;
  }
  .supplier-details tr {
    border: 1px solid #eff2f7 !important;
    padding : 0.35rem !important;
  }
  </style>